import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { experienciasApi } from '../../api/experiencias'
import { colors, font } from '../../design/tokens'
import { BotonPrimario, Card, Cargando, ErrorMsg, Titulo, Vacio } from './comunes'

// Experiencias en el celular (Martin, 24 sep 2026): las que vienen, para ver
// quién confirmó y mandar las invitaciones desde el teléfono. Las que ya
// pasaron y las archivadas quedan en LGR completo.
export default function MovilExperiencias() {
  const navigate = useNavigate()
  const [lista, setLista] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    experienciasApi.listar()
      .then(({ data }) => {
        const hoy = new Date().toISOString().slice(0, 10)
        setLista(
          data.experiencias
            .filter((e) => !e.archivada && e.articulo_id && (!e.fecha_evento || e.fecha_evento.slice(0, 10) >= hoy))
            .sort((a, b) => (a.fecha_evento || '9999').localeCompare(b.fecha_evento || '9999')),
        )
      })
      .catch(() => setError('No se pudieron cargar las experiencias'))
  }, [])

  return (
    <div>
      <Titulo>Experiencias</Titulo>
      <BotonPrimario onClick={() => navigate('/m/experiencias/nueva')} style={{ marginBottom: 12 }}>
        ＋ Nueva experiencia
      </BotonPrimario>
      {error && <ErrorMsg>{error}</ErrorMsg>}
      {!lista && !error && <Cargando />}
      {lista && lista.length === 0 && <Vacio>No hay experiencias próximas con venta.</Vacio>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {(lista || []).map((e) => (
          <Card key={e.id} onClick={() => navigate(`/m/experiencias/${e.id}`)}>
            <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 16, color: colors.text }}>{e.titulo}</span>
            <span style={{ display: 'block', fontSize: 12.5, color: colors.textSec, fontFamily: font.sans, marginTop: 2 }}>
              {[e.cuando, e.lugar].filter(Boolean).join(' · ')}
            </span>
          </Card>
        ))}
      </div>
    </div>
  )
}
